// extracted by mini-css-extract-plugin
module.exports = {"form":"AddNoteForm_form__3boTN","attachments":"AddNoteForm_attachments__2-PNQ","btns":"AddNoteForm_btns__3zGzU"};